import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

import { DRAWER_WIDTH } from '@uptime/shared/constants';

const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    display: 'flex',
    backgroundColor: 'white',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    color: `${theme.palette.grey.black} !important`,
    backgroundColor: `${theme.palette.grey.white} !important`,
    boxShadow: `none !important`,
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    marginLeft: `${DRAWER_WIDTH}px`,
    borderRadius: `0 !important`,
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${DRAWER_WIDTH}px) !important`,
    },
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      display: 'none !important',
    },
  },
  menuButtonHidden: {
    display: 'none',
  },
  userName: {
    fontSize: 14,
    marginRight: theme.spacing(2) + ' !important',
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflowX: 'hidden',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    minHeight: 500,
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
  logoutBtn: {
    color: theme.palette.primary + ' !important',
  },
}));

export default useStyles;
